import React from 'react';
import Prism from 'prismjs';
// import 'prismjs/themes/prism-okaidia.css';
import 'prismjs/components/prism-xml-doc.min.js';
import 'prismjs/components/prism-mongodb.min.js';
import 'prismjs/components/prism-json.min.js';
import 'prismjs/plugins/keep-markup/prism-keep-markup.js';
import 'prismjs/plugins/toolbar/prism-toolbar.min.js';
import 'prismjs/plugins/toolbar/prism-toolbar.css';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.min.js';
import 'prismjs/plugins/line-numbers/prism-line-numbers.min.js';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import 'prismjs/plugins/line-highlight/prism-line-highlight.min.js';
import 'prismjs/plugins/line-highlight/prism-line-highlight.css';
import PropTypes from 'prop-types';
import './Code.css';

export default class Code extends React.Component {

  constructor (props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount () {
    this.highlight();
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.code !== this.props.code) { this.highlight(); }
  }

  highlight = () => {
    if (this.ref && this.ref.current) {
      Prism.highlightElement(this.ref.current);
    }
  };

  render () {
    const { code, plugins, language, lineHighlight, caption, live, error, downloadFilename } = this.props;
    let url;
    if (downloadFilename) {
      // eslint-disable-next-line no-undef
      const blob = new Blob([JSON.stringify(JSON.parse(code), null, 2)], { type: 'application/json' });
      url = URL.createObjectURL(blob);
    }
    return (
      <div key={code} className={'codePanel' + (live ? ' live' : '') + (error ? ' error' : '')}>
        {caption &&
            <div className="caption">{caption}{live && <span className="liveTag">live</span>}</div>
        }
        {downloadFilename &&
          <a href={url} download={downloadFilename} className="download">
            Download
          </a>
        }
        <pre className={!plugins ? '' : plugins.join(' ')} data-line={!lineHighlight ? '' : lineHighlight}>
          <code ref={this.ref} className={`language-${language} keep-markup`}>
            {/* MS: Um die normale funktionsweise der Plugins von Prism herstellen zu können wird standard-HTML erwartet */}
            {(this.props.embed === undefined || this.props.embed)
              ? <span dangerouslySetInnerHTML={{ __html: code }}/>
              : code
            }
          </code>
        </pre>
      </div>
    );
  }

}
Code.propTypes = {
  caption: PropTypes.any,
  code: PropTypes.string,
  language: PropTypes.string,
  plugins: PropTypes.array,
  lineHighlight: PropTypes.array || PropTypes.string,
  embed: PropTypes.bool,
  live: PropTypes.bool,
  error: PropTypes.bool,
  downloadFilename: PropTypes.string
};
